var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.color)?_c('span',{staticClass:"inline-flex items-center gap-1 whitespace-nowrap"},[_c('span',{staticClass:"ral-swatch",style:({ background: _vm.hex || 'transparent' })}),_vm._v(" "+_vm._s(_vm.color)+" ")]):_c('span',{staticClass:"text-gray-400"},[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }